import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import declOfNum from '~/utils/decl-of-num';

import styles from './styles.module.css';

interface Props {
  maxCounter: number;
  titles: [string, string, string];
  isShowAnimation: boolean;
}

const CountItem: React.FC<Props> = ({ maxCounter, titles, isShowAnimation }) => {
  const [currentCounter, setCurrentCounter] = useState<number>(0);
  const [secondClassName, setSecondClassName] = useState<string>();

  const animatedCounter = (): void => {
    let counter = currentCounter;
    //вычисление шага счетчика для больших значений maxCounter, чтобы уменьшить кол-во рендеров блока
    const stepCoefficient =
      maxCounter >= 500 && !(maxCounter % 10) ? (maxCounter >= 1000 && !(maxCounter % 20) ? 20 : 10) : 1;

    const animatedInterval = setInterval(
      () => {
        counter += stepCoefficient;
        setCurrentCounter(counter);

        if (counter === maxCounter) {
          clearInterval(animatedInterval);
        }
      },
      (700 / maxCounter) * stepCoefficient * 4
    );
  };

  useEffect(() => {
    if (isShowAnimation) {
      animatedCounter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowAnimation]);

  useEffect(() => {
    if (maxCounter >= 1000) {
      setSecondClassName(styles.counterLarge);
    } else if (maxCounter >= 100 && maxCounter < 1000) {
      setSecondClassName(styles.counterMiddle);
    } else {
      setSecondClassName(styles.counterSmall);
    }
  }, [maxCounter]);

  return (
    <div className={styles.container}>
      <p className={clsx(styles.counter, secondClassName)}>{currentCounter}</p>
      <p className={styles.title}>{declOfNum(maxCounter, titles)}</p>
    </div>
  );
};

export default CountItem;
